<div class="content-header-left breadcrumb-new" *ngIf="breadcrumb">
  <h1 class="content-header-title d-inline-block">{{breadcrumb.mainlabel}}</h1>
  <div class="row breadcrumbs-top d-inline-block">
    <div class="breadcrumb-wrapper col-12">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" *ngFor="let link of breadcrumb.links">
          <a class="primary"
          *ngIf="link.isLink" routerLink="{{link.link}}">{{link.name}}</a>
          <span *ngIf="!link.isLink">{{link.name}}</span>
        </li>
      </ol>
    </div>
  </div>
</div>
  
